import { StackScreenProps } from "@react-navigation/stack";
import { ManageProductTagsRootParamList } from "../../../../types";
import {
  Button,
  FlatActionList,
  Page,
  Text,
} from "@towersystems/roam-common-native";
import React from "react";
import { ProductFormValues } from "../../components/ProductForm/types";
import { useFormContext } from "react-hook-form";
import { EmptyList } from "../../../../components/EmptyList";
import { AntDesign } from "@expo/vector-icons";
import { useTranslation } from "../../../../utilities/i18n";

export type ManageProductTagsScreenProps = StackScreenProps<
  ManageProductTagsRootParamList,
  "ManageProductTagsScreen"
>;

export const ManageProductTagsScreen = ({
  navigation,
}: ManageProductTagsScreenProps) => {
  const { t } = useTranslation("product");
  const { watch, setValue } = useFormContext<ProductFormValues>();

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label={t("button.add_tag")}
          isAction
          onPress={() => {
            //@ts-ignore
            navigation.navigate("AddProductTagScreen");
          }}
          size="compact"
        ></Button>
      ),
    });
  }, []);

  const watchedTags = watch("tags");

  const emptyTagsMarkup = watchedTags.length === 0 && (
    <EmptyList
      title={t("empty_tag_list_title")}
      description={t("emtpty_tag_list_description")}
      style={{
        alignItems: "flex-start",
      }}
    />
  );

  return (
    <Page title={t("manage_tag_title")}>
      {emptyTagsMarkup}
      <FlatActionList
        items={watchedTags.map((tag) => ({
          key: tag,
          title: tag,
          onPress: () => {
            const tags = watchedTags.filter((t) => t !== tag);
            setValue("tags", tags, {
              shouldValidate: true,
              shouldDirty: true,
            });
          },
          componentRight: () => (
            <Text color="destructive">
              <AntDesign name="delete" size={24} />
            </Text>
          ),
        }))}
      />
    </Page>
  );
};
